import i18nFactory from '@yandex-int/i18n';
import * as Cookie from 'js-cookie';
import { omit } from 'lodash';
import { push, Query, replace } from 'redux-little-router';
import { Epic, ofType } from 'redux-observable';
import { EMPTY, forkJoin, from, Observable, of, timer } from 'rxjs';
import {
    audit,
    catchError,
    debounceTime,
    filter,
    first,
    map,
    mergeMap,
    switchMap
} from 'rxjs/operators';
import { Error } from 'tslint/lib/error';

import { Action } from '../../actions';
import {
    LOAD_BANNERS_PREVIEW,
    LoadBannersPreviewAction,
    updateBannersPreview
} from '../../actions/banners-preview';
import {
    changeLocation,
    DummyAction,
    dummyAction,
    showCommonDataFetchError,
    UPDATE_AUTHORIZATION_DATA,
    updateDocumentTitle
} from '../../actions/common';
import {
    BIND_MINUS_PHRASE_TO_GRID_GROUPS,
    CLOSE_ALERT_GRID_ERROR,
    closeEditPopup,
    closeMinusPhraseSelectorGridModal,
    ENTITY_ADD_SUCCESS,
    ENTITY_EDIT_SUCCESS,
    EntityAddSuccess,
    FETCH_GRID_GROUPS_COUNTS,
    FETCH_SUGGEST_DATA,
    FETCH_TOOLTIP_DATA,
    fetchGridGroupsCounts,
    FetchTooltipData,
    GET_BANNER_MODERATION_REJECT_REASONS,
    GET_GRID_RECOMMENDATION_APPLY_STATUS,
    GET_GROUP_MODERATION_REJECT_REASONS,
    GetBannnerModerationRejectReasons,
    getGridRecommendationApplyStatus,
    GetGridRecommendationApplyStatus,
    GetGroupModerationRejectReasons,
    GRID_FETCH_ADJUSMENT_INFO,
    gridChangeAdjustmentData,
    GridFetchAdjustmentInfo,
    NoticeType,
    ON_GRID_SOURCE_PARAMS_CHANGED,
    OnGridSourceParamsChanged,
    OPEN_DUPLICATE_GROUPS_MODAL,
    OPEN_MINUS_PHRASE_SELECTOR_GRID_MODAL,
    OpenDuplicateGroupsModal,
    REQUEST_GRID_ROW,
    RequestGridRow,
    RESET_GRID_DATA,
    resetGridData,
    resetSuggestData,
    SET_GRID_DOCUMENT_TITLE,
    setBannerAimingPopup,
    setBannerAimingPopupPending,
    setBannerModerationRejectReasonsError,
    setGroupModerationRejectReasonsError,
    SHOW_MINUS_PHRASE_BIND_SUCCESS_MESSAGE,
    SHOW_MINUS_PHRASE_UNBIND_SUCCESS_MESSAGE,
    ShowErrorMinusPhraseItemsGridInModal,
    showErrorMinusPhraseItemsGridInModal,
    ShowMinusPhraseBindSuccessMessage,
    showMinusPhraseBindSuccessMessage,
    ShowMinusPhraseUnbindSuccessMessage,
    showMinusPhraseUnbindSuccessMessage,
    showNoticeMessage,
    START_BANNER_AIMING,
    StartBannerAimingAction,
    SUBMIT_GRID_SCREEN_RECOMMENDATION_ITEM,
    SubmitGridScreenRecommendationItem,
    SWICH_ONLY_FAVORITE_CAMPAIGNS_FILTER,
    SWITCH_TO_OLD_INTERFACE,
    UNBIND_MINUS_PHRASE_TO_GRID_GROUPS,
    UPDATE_ADDITIONAL_FILTER,
    UPDATE_ADJUSTMENT_FORECAST,
    UPDATE_CALC_TYPE_FILTER,
    UPDATE_GRID_FILTER_DICT,
    UPDATE_GRID_FILTER_PERIOD,
    updateActionProgress,
    UpdateAdjustmentForecast,
    updateBannerModerationRejectReasons,
    UpdateCalcTypeFilter,
    updateDuplicateGroupsItemsData,
    updateFeatures,
    updateGridData,
    UpdateGridFilterDict,
    UpdateGridFilterPeriod,
    updateGridScreenRecommendationItem,
    UpdateGridSelection,
    updateGroupModerationRejectReasons,
    UpdateMinusPhraseItemsGridInModal,
    updateMinusPhraseItemsGridInModal,
    updateSelection,
    updateSuggestData,
    updateTooltipData
} from '../../actions/grid-screen';
import { closeHelp, OPEN_HELP, OpenHelp, updateHelp } from '../../actions/help';
import {
    FINISH_SEARCH_AND_REPLACE_LOADING,
    FinishSearchAndReplaceLoading,
    finishSearchAndReplaceLoading,
    GET_PHRASE_REPLACE_PREVIEW,
    PhrasesGridAction,
    REPLACE_PHRASES,
    ResetSearchAndReplaceInspectorState,
    resetSearchAndReplaceInspectorState,
    ShowReplacePhrasesError,
    showReplacePhrasesError,
    updateSearchAndReplaceInspectorPreview
} from '../../actions/phrases-grid';
import { SuggestQueryResponse } from '../../api/grid/EntitiesDataProvider';
import { FetchMinusPhraseLibraryDataResult } from '../../api/MinusPhraseLibraryProvider/MinusPhraseLibraryProvider';
import {
    AjaxPhraseStatResponse,
    RefineMinusWordsResponse
} from '../../api/RestApiManager';
import {
    GroupCriteriaKey,
    GroupCriteriaSetTitles
} from '../../declarations/filter/filter';
import {
    expressionToString,
    mapCampaignTypeToCalcType
} from '../../mappers/filter/filter';
import {
    EXTERNAL_ID_KEY,
    EXTERNAL_REASON_KEY,
    mapBannerModerationRejectReasonsFromApiFormat,
    mapExternalModerationRejectReasonFromApiFormat,
    mapGroupModerationRejectReasonsFromApiFormat,
    mapModerationEmailContactFromApiFormat,
    OTHER_REASON_KEY,
    OUTDOOR_ID_KEY
} from '../../mappers/moderation';
import {
    mapRefineMinusWordsReponseToAdjustmentItems,
    mapSearchAndReplaceFormValueToApiFormat,
    mapToPhraseReplacePreviewData
} from '../../mappers/phrase/phrase';
import { RoutesPath } from '../../routes/index';
import {
    selectGridAdditionalFilter,
    selectOnlyFavoriteCampaigns
} from '../../selectors/grid/grid';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { ApiMethodExecutingError, NotSyncedError } from '../../service/Errors';
import { getErrorMessage } from '../../service/GraphqlErrorHelper/GraphqlErrorHelper';
import {
    normalizeIds,
    showNoticeMessageWithLink
} from '../../service/GridHelpers/GridHelpers';
import { isSelectedMoreThenInGrid } from '../../service/gridItemsActionsHelpers/gridItemsActionsHelpers';
import { GridScreenLinkBuilder } from '../../service/GridScreenLinkBuilder';
import { GridSourceHelper } from '../../service/GridSourceHelper';
import {
    getErrorMinusPhraseBindingMessage,
    getErrorMinusPhraseUnbindingMessage,
    getSuccessMinusPhraseBindingMessage,
    getSuccessMinusPhraseUnbindingMessage
} from '../../service/MinusPhraseService/MinusPhraseService';
import {
    ERROR_PROPORTION_CHECKPOINT,
    SUCCESS_PROPORTION_CHECKPOINT
} from '../../service/NoticeTypeHelper/NoticeTypeHelper';
import { pluralizeLocalWord } from '../../service/Pluralize/Pluralize';
import {
    getGridRecommendationApplyStatusMessage,
    getGridRecommendationErrorStatusMessage,
    getGridRecommendationWithRefreshErrorStatusMessage
} from '../../service/RecommendationsHelpers/RecommendationsHelpers';
import { requestHiddenFrame } from '../../service/RequestHiddenFrame/RequestHiddenFrame';
import '../../service/Rx';
import { RequestIndexResult } from '../../service/SegmentManager';
import { Session } from '../../service/Session/Session';
import { EpicDeps } from '../../service/StoreFactory';
import { UrlHelpers } from '../../service/UrlHelpers';
import {
    banners,
    campaigns,
    clients,
    ErrorResponseType,
    GRID_PREFIX,
    groups
} from '../../typings/common';
import { Banner, CampaignsCalcTypeFilter, Group } from '../../typings/domain';
import { FilterExpressionValueType, Operator } from '../../typings/filter';
import { GoalDecl } from '../../typings/goals';
import {
    FindAndReplaceKeywordsMutation,
    FindAndReplaceKeywordsPreview,
    GdRecommendationStatus,
    GdUpdateAdGroupMinusKeywordsActionInput,
    RecommendationsStatusesQuery,
    RecommendationStatus
} from '../../typings/graphql-grid';
import {
    GridAlertMessageType,
    GridContextType,
    GridEditedEntityType,
    GridScreenUrlSearchQueryParams,
    GridViewType
} from '../../typings/grid';
import { DuplicateItem } from '../../typings/groups';
import { MinusPhraseLibraryRow } from '../../typings/minusPhraseLibrary';
import {
    ModerationRejectKey,
    ModerationRejectOutdoorReasonsItem,
    ModerationRejectReason,
    OutdoorRejectFullReason
} from '../../typings/moderation';
import { MinusPhraseSelectorItemsData, State } from '../../typings/state';

import * as keyset from './grid-screen.i18n';

const i18n = i18nFactory(keyset);
const updateSourceParamsEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    const updateSourceParamsActions = action$.ofType(
        ON_GRID_SOURCE_PARAMS_CHANGED
    );

    const needDataFetchActions = updateSourceParamsActions.distinctUntilChanged(
        (prev: OnGridSourceParamsChanged, next: OnGridSourceParamsChanged) => {
            const storeData = store$.value;
            const {
                goalsData: { goals },
                commonData: {
                    features: { isGoalsStatEnabled }
                },
                grid: { campaignsCalcTypeFilter }
            } = storeData;

            const hasOnlyCpmCampaigns =
                campaignsCalcTypeFilter === CampaignsCalcTypeFilter.CPM;

            return !GridSourceHelper.areParamsMeaningfullyDifferent(
                next.params,
                prev.params,
                hasOnlyCpmCampaigns,
                goals,
                isGoalsStatEnabled,
                storeData.grid.clientInfo
            );
        }
    );

    const resetSuggestDataActions = updateSourceParamsActions
        .distinctUntilChanged(
            (
                prev: OnGridSourceParamsChanged,
                next: OnGridSourceParamsChanged
            ) => {
                const storeData = store$.value;

                const {
                    grid: { campaignsCalcTypeFilter }
                } = storeData;

                const hasOnlyCpmCampaigns =
                    campaignsCalcTypeFilter === CampaignsCalcTypeFilter.CPM;

                return !GridSourceHelper.areParamsMapsToDifferentRowsets(
                    next.params,
                    prev.params,
                    storeData.grid.clientInfo,
                    hasOnlyCpmCampaigns
                );
            }
        )
        .mapTo(resetSuggestData());

    const clearCalcTypeFromUrl = updateSourceParamsActions
        .filter(() => {
            const state = store$.value;
            const { query = {} } = state.router;

            return Boolean(query[GridScreenUrlSearchQueryParams.calcType]);
        })
        .map(() => {
            const state = store$.value;
            const { pathname, query = {} } = state.router;
            const { login } = state.commonData;
            const urlCalcType = query[GridScreenUrlSearchQueryParams.calcType];
            const calcType = CampaignsCalcTypeFilter[urlCalcType];

            if (calcType) {
                Session.setValueToCurrentSession(login, {
                    campaignsCalcTypeFilter: calcType
                });
            }

            return replace({
                pathname: pathname,
                query: omit(query, [GridScreenUrlSearchQueryParams.calcType])
            });
        });

    const clearIdsFromContext = updateSourceParamsActions
        .filter(() => {
            const state = store$.value;
            const { query = {} } = state.router;
            const urlCampaignsIds =
                query[GridScreenUrlSearchQueryParams.campaignsIds];
            const urlGroupsIds =
                query[GridScreenUrlSearchQueryParams.groupsIds];

            return Boolean(urlGroupsIds || urlCampaignsIds);
        })
        .map(() => {
            const state = store$.value;
            const { pathname, query = {} } = state.router;
            const { login } = state.commonData;
            const sourceParams = selectGridSourceParams(state);

            const urlCampaignsIds =
                query[GridScreenUrlSearchQueryParams.campaignsIds];
            const urlGroupsIds =
                query[GridScreenUrlSearchQueryParams.groupsIds];

            let campaignsIds = normalizeIds(urlCampaignsIds);
            let groupsIds = normalizeIds(urlGroupsIds);

            let newQuery = query;

            switch (sourceParams.context) {
                case clients:
                    campaignsIds = [];
                    groupsIds = [];
                    break;
                case campaigns:
                    groupsIds = [];
                    break;
                case groups:
                    break;
                default:
                    throw new Error('unknown grid context type');
            }

            Session.setValueToCurrentSession(login, {
                campaignsIds,
                groupsIds
            });

            if (urlGroupsIds || urlCampaignsIds) {
                newQuery = omit(query, [
                    GridScreenUrlSearchQueryParams.campaignsIds,
                    GridScreenUrlSearchQueryParams.groupsIds
                ]);
            }

            return replace({
                pathname: pathname,
                query: newQuery
            });
        });

    return clearIdsFromContext.merge(
        clearCalcTypeFromUrl.merge(
            resetSuggestDataActions.merge(
                needDataFetchActions
                    .filter(() => {
                        const { total, data } = store$.value.grid.gridData;

                        return Boolean(total && data.length !== 0);
                    })
                    .mapTo(resetGridData())
            )
        )
    );
};

const updateAdditionalFilterEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$.ofType(UPDATE_ADDITIONAL_FILTER).mapTo(resetGridData());
};

const updateCalcTypeFilterEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$
        .ofType(UPDATE_CALC_TYPE_FILTER)
        .map((action: UpdateCalcTypeFilter) => {
            const state = store$.value;
            const { login } = state.commonData;

            Session.setValueToCurrentSession(login, {
                campaignsCalcTypeFilter: action.calcTypeFilter
            });

            return resetGridData();
        });
};

// todo DIRECT-78850
const resetGridDataEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    action$.ofType(RESET_GRID_DATA).subscribe(() => {
        deps.segmentManager.reset();
    });

    return EMPTY;
};

const fetchSuggestDataEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$
        .ofType(FETCH_SUGGEST_DATA)
        .filter(() => !store$.value.grid.isSuggestItemsRequested)
        .mergeMap(
            (): Observable<Action> => {
                const state = store$.value;
                const cacheKey = state.grid.gridData.cacheKey;
                const sourceParams = selectGridSourceParams(state);
                const additionalFilter = selectGridAdditionalFilter(state);
                const campaignsCalcTypeFilter =
                    state.grid.campaignsCalcTypeFilter;

                return Observable.fromPromise(
                    deps.entitiesDataProvider.fetchSuggestData(
                        {
                            ...sourceParams,
                            additionalFilter: additionalFilter
                                ? additionalFilter.additionalFilterValue
                                : undefined,
                            campaignsCalcTypeFilter
                        },
                        state.grid.clientInfo,
                        cacheKey
                    )
                )
                    .map((suggestData: SuggestQueryResponse) =>
                        updateSuggestData(suggestData.data)
                    )
                    .catch(() => Observable.of(dummyAction));
            }
        );
};

const requestRowEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(REQUEST_GRID_ROW),
        filter(() => {
            const { route } = store$.value.router;

            return route === RoutesPath.shortGrid || route === RoutesPath.grid;
        }),
        map(({ index }: RequestGridRow) => {
            return deps.segmentManager.requestIndex(index);
        }),
        filter(res => res !== null),
        filter(({ isNeedFetch }: RequestIndexResult) => isNeedFetch),
        mergeMap(({ offset, count }: RequestIndexResult) => {
            const state = store$.value;
            const { commonData } = state;
            const sourceParams = selectGridSourceParams(state);
            const cacheKey = state.grid.gridData.cacheKey;
            const additionalFilter = selectGridAdditionalFilter(state);
            const campaignsCalcTypeFilter = state.grid.campaignsCalcTypeFilter;
            const isOnlyFavoriteCampaignsVisible = selectOnlyFavoriteCampaigns(
                state
            );

            return from(
                deps.entitiesDataProvider.fetchGridDataSegment(
                    {
                        ...sourceParams,
                        additionalFilter: additionalFilter
                            ? additionalFilter.additionalFilterValue
                            : undefined,
                        campaignsCalcTypeFilter,
                        isOnlyFavoriteCampaignsVisible: isOnlyFavoriteCampaignsVisible
                    },
                    state.grid.clientInfo,
                    offset,
                    count,
                    cacheKey
                )
            ).pipe(
                filter(() => {
                    const newSourceParams = selectGridSourceParams(
                        store$.value
                    );

                    return sourceParams.view === newSourceParams.view;
                }),
                mergeMap(response => {
                    const storeData = store$.value;
                    const data = response.data.data.reduce((res, item, pos) => {
                        res[offset + pos] = item;

                        return res;
                    }, storeData.grid.gridData.data.slice());

                    deps.segmentManager.setTotal(response.data.total);

                    let goalsSettings: GoalDecl[] | undefined;

                    if (commonData && commonData.login) {
                        const sessionValue = Session.getValueFromCurrentLocalSession(
                            commonData.login
                        );
                        goalsSettings = sessionValue.goalsSettings;
                    }

                    let result: Observable<Action> = of(
                        updateGridData({
                            gridData: {
                                ...response.data,
                                data,
                                totalStats: response.totalStats
                                    ? response.totalStats
                                    : storeData.grid.gridData.totalStats
                            },
                            clientInfo: response.clientInfo,
                            hasObjectsOverLimit: response.hasObjectsOverLimit,
                            gridReqId: response.reqId,
                            phraseContextData: response.phraseContextData,
                            goalsSettings
                        })
                    );
                    if (
                        response.clientInfo.isInternalAdsAllowed !==
                        storeData.grid.clientInfo.isInternalAdsAllowed
                    ) {
                        // Некоторые фильтры включаются по фиче: сбрасываем данные по гридам,
                        // они делают новый запрос с нужными фильтрами
                        result = result.merge(of(resetGridData()));
                    }

                    if (
                        sourceParams &&
                        sourceParams.view === groups &&
                        storeData.grid.gridActionFeatures === undefined
                    ) {
                        const {
                            selectionInfo: { groups: selectionInfoGroups }
                        } = storeData.grid;

                        if (
                            isSelectedMoreThenInGrid(selectionInfoGroups, data)
                        ) {
                            result = result.merge(
                                of(updateActionProgress(true))
                            );
                        }

                        result = result.merge(of(fetchGridGroupsCounts()));
                    } else {
                        result = result.merge(of(updateActionProgress(false)));
                    }

                    return result;
                })
            );
        }),
        catchError((err: ApiMethodExecutingError | string) => {
            return of(
                showCommonDataFetchError(
                    err,
                    err instanceof ApiMethodExecutingError
                        ? err.getType() === ErrorResponseType.network
                        : false
                )
            );
        })
    );
};

const fetchGridGroupsCountsEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$
        .ofType(FETCH_GRID_GROUPS_COUNTS)
        .mergeMap(() => {
            const state = store$.value;
            const cacheKey = state.grid.gridData.cacheKey;
            const sourceParams = selectGridSourceParams(state);
            const additionalFilter = selectGridAdditionalFilter(state);

            return Observable.fromPromise(
                deps.entitiesDataProvider.fetchGridGroupsCounts(
                    {
                        ...sourceParams,
                        additionalFilter: additionalFilter
                            ? additionalFilter.additionalFilterValue
                            : undefined
                    },
                    state.grid.clientInfo,
                    cacheKey
                )
            ).map(features => updateFeatures(features));
        })
        .catch(() => {
            showNoticeMessage(
                NoticeType.error,
                i18n('mass-actions-server-error')
            );
            return Observable.of(
                updateFeatures({
                    canBeSentToBSAdGroupsCount: 0,
                    canRemoderateAdsCalloutsCount: 0,
                    canAcceptAdsCalloutsModerationCount: 0,
                    canBeDeletedAdGroupsCount: 0,
                    canBeSentToModerationAdGroupsCount: 0,
                    canBeSentToRemoderationAdGroupsCount: 0,
                    canAcceptModerationAdGroupsCount: 0,
                    canBeSentToModerationByClientAdGroupsCount: 0,
                    canBeCopied: 0
                })
            );
        });
};

const fetchTooltipDataEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$
        .ofType(FETCH_TOOLTIP_DATA, OPEN_HELP)
        .filter(({ id }: FetchTooltipData | OpenHelp) => {
            const { tooltips } = store$.value.grid;

            return tooltips[id] === undefined;
        })
        .mergeMap(({ id, type }: FetchTooltipData | OpenHelp) => {
            return Observable.fromPromise(deps.docCenterApi.getTooltipText(id))
                .mergeMap(data => {
                    let result: Observable<Action> = Observable.of(
                        updateTooltipData(data)
                    );
                    if (type === OPEN_HELP) {
                        result = result.merge(Observable.of(updateHelp(data)));
                    }
                    return result;
                })
                .catch((error: ApiMethodExecutingError) => {
                    let result: Observable<Action> = Observable.of(dummyAction);

                    if (type === OPEN_HELP) {
                        showNoticeMessage(NoticeType.error, error.getMessage());
                        result = Observable.of(closeHelp);
                    }

                    return result;
                });
        });
};

const replacePhrasesEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(REPLACE_PHRASES).mergeMap(() => {
        const state = store$.value;
        const sourceParams = selectGridSourceParams(state);
        const currentGridState = store$.value.grid;
        const {
            selectionInfo: { phrases: selectedPhrases },
            searchAndReplaceInspectorState
        } = currentGridState;

        const replacePhrases$ = Observable.fromPromise(
            deps.phrasesMutationExecutor.findAndReplaceKeywords(
                mapSearchAndReplaceFormValueToApiFormat(
                    searchAndReplaceInspectorState,
                    selectedPhrases
                ),
                sourceParams.login
            )
        );

        return replacePhrases$
            .map((result: FindAndReplaceKeywordsMutation) => {
                const { updatedTotalCount } = result.findAndReplaceKeywords;

                return finishSearchAndReplaceLoading(
                    i18n('search-and-replace-success', {
                        updatedTotalCount: updatedTotalCount,
                        selectedCount: selectedPhrases.length,
                        phraseWord: pluralizeLocalWord(
                            [
                                i18n('phrase-1'),
                                i18n('phrase-2'),
                                i18n('phrase-5')
                            ],
                            selectedPhrases.length
                        )
                    })
                );
            })
            .merge(
                replacePhrases$.mapTo(updateSelection([])),
                replacePhrases$.mapTo(resetGridData()),
                replacePhrases$.mapTo(resetSearchAndReplaceInspectorState())
            )
            .catch(
                (
                    err: ApiMethodExecutingError
                ): Observable<
                    | ResetSearchAndReplaceInspectorState
                    | UpdateGridSelection
                    | ShowReplacePhrasesError
                    | FinishSearchAndReplaceLoading
                > => {
                    if (err instanceof NotSyncedError) {
                        return Observable.concat(
                            Observable.of(
                                resetSearchAndReplaceInspectorState()
                            ),
                            Observable.of(updateSelection([]))
                        );
                    } else {
                        return Observable.concat(
                            Observable.of(
                                showReplacePhrasesError(err.getMessage())
                            ),
                            Observable.of(finishSearchAndReplaceLoading())
                        );
                    }
                }
            );
    });
};

const getPhrasesReplacePreviewEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(GET_PHRASE_REPLACE_PREVIEW).mergeMap(() => {
        const currentGridState = store$.value.grid;
        const state = store$.value;
        const sourceParams = selectGridSourceParams(state);

        const getReplacePreviewData$ = Observable.fromPromise(
            deps.phraseQueryProvider.findAndReplaceKeywordsPreview(
                mapSearchAndReplaceFormValueToApiFormat(
                    currentGridState.searchAndReplaceInspectorState,
                    currentGridState.selectionInfo.phrases
                ),
                sourceParams.login
            )
        );

        const updatePreview$ = getReplacePreviewData$
            .map(mapToPhraseReplacePreviewData)
            .map(updateSearchAndReplaceInspectorPreview);

        return updatePreview$
            .merge(
                getReplacePreviewData$.map(
                    ({
                        getFindAndReplaceKeywordsPreview: { validationResult }
                    }: FindAndReplaceKeywordsPreview) => {
                        if (
                            validationResult &&
                            validationResult.errors.length
                        ) {
                            const [firstError] = validationResult.errors;
                            return showReplacePhrasesError(
                                getErrorMessage(firstError)
                            );
                        }

                        return dummyAction;
                    }
                ),
                getReplacePreviewData$.mapTo(finishSearchAndReplaceLoading())
            )
            .catch((err: ApiMethodExecutingError) =>
                Observable.of<PhrasesGridAction>(
                    showReplacePhrasesError(err.getMessage()),
                    finishSearchAndReplaceLoading()
                )
            );
    });
};

const finishSearchAndReplaceLoadingEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$
        .ofType(FINISH_SEARCH_AND_REPLACE_LOADING)
        .map((action: FinishSearchAndReplaceLoading) => {
            if (action.successMessage) {
                showNoticeMessage(NoticeType.success, action.successMessage);
            }

            return dummyAction;
        });
};

const switchToOldInterfaceEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(SWITCH_TO_OLD_INTERFACE).map(() => {
        const state = store$.value;
        const sourceParams = selectGridSourceParams(state);

        deps.restApiManager.switchToOldInterface(sourceParams);
        return dummyAction;
    });
};

const loadBannersPreviewEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(LOAD_BANNERS_PREVIEW).mergeMap(
        (action: LoadBannersPreviewAction): Observable<Action> => {
            const state = store$.value;
            const { clientInfo } = state.grid;
            const additionalFilter = selectGridAdditionalFilter(state);
            const sourceParams = selectGridSourceParams(state);

            return Observable.fromPromise(
                deps.entitiesDataProvider.getBannersPreview(
                    {
                        ...sourceParams,
                        additionalFilter: additionalFilter
                            ? additionalFilter.additionalFilterValue
                            : undefined
                    },
                    clientInfo,
                    [action.campaignId],
                    [action.groupId]
                )
            )
                .map((bannerItems: Banner[]) => {
                    return updateBannersPreview({
                        [action.groupId]: {
                            banners: bannerItems
                        }
                    });
                })
                .catch(() => {
                    return Observable.of(
                        updateBannersPreview({
                            [action.groupId]: {
                                error: i18n('failed-to-load-banners-for-popup')
                            }
                        })
                    );
                });
        }
    );
};

const submitGridRecommendationEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$
        .ofType(SUBMIT_GRID_SCREEN_RECOMMENDATION_ITEM)
        .mergeMap(
            ({
                keys,
                id,
                recommendationType,
                itemName
            }: SubmitGridScreenRecommendationItem) => {
                const setProgressStatus$ = Observable.of(
                    updateGridScreenRecommendationItem(
                        id,
                        recommendationType,
                        GdRecommendationStatus.IN_PROGRESS
                    )
                );

                const makeRequest$ = Observable.fromPromise(
                    deps.recommendationsMutationExecutor.executeRecommendation(
                        keys
                    )
                )
                    .mapTo(
                        getGridRecommendationApplyStatus(
                            recommendationType,
                            keys,
                            itemName
                        )
                    )
                    .catch(() => {
                        showNoticeMessage(
                            NoticeType.error,
                            getGridRecommendationWithRefreshErrorStatusMessage(
                                recommendationType,
                                itemName
                            )
                        );

                        return Observable.of(
                            updateGridScreenRecommendationItem(
                                id,
                                recommendationType,
                                GdRecommendationStatus.READY
                            )
                        );
                    });

                return Observable.concat(setProgressStatus$, makeRequest$);
            }
        );
};

const setGridDocumentTitleEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.pipe(
        ofType(SET_GRID_DOCUMENT_TITLE),
        audit(() => {
            if (store$.value.commonData.authorizationData) {
                return EMPTY;
            }

            return action$.pipe(ofType(UPDATE_AUTHORIZATION_DATA));
        }),
        switchMap(() => {
            const {
                commonData: { authorizationData, login }
            } = store$.value;

            let screenTitle = i18n('client-campaigns');

            if (!authorizationData) {
                return EMPTY;
            }

            if (
                !authorizationData.login ||
                authorizationData.login === login.toLowerCase()
            ) {
                screenTitle = i18n('my-campaigns');
            }

            return [updateDocumentTitle(screenTitle)];
        })
    );
};

const getGridRecommendationApplyStatusEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(GET_GRID_RECOMMENDATION_APPLY_STATUS),
        mergeMap(
            (action: GetGridRecommendationApplyStatus): Observable<Action> => {
                const GET_STATUS_INTERVAL = 2000;

                const state = store$.value;
                const ulogin = state.commonData.login;

                return timer(0, GET_STATUS_INTERVAL).pipe(
                    switchMap(() =>
                        from(
                            deps.recommendationsDataProvider.getRecommendationsStatus(
                                ulogin,
                                action.keys
                            )
                        )
                    ),
                    first(
                        (data: RecommendationsStatusesQuery) =>
                            data.client.recommendationsStatuses.length !== 0
                    ),
                    mergeMap(
                        (
                            data: RecommendationsStatusesQuery
                        ): Observable<Action> => {
                            const recommendationStatus =
                                data.client.recommendationsStatuses &&
                                data.client.recommendationsStatuses[0];

                            const isRecommendationSuccess =
                                recommendationStatus &&
                                recommendationStatus.status !==
                                    RecommendationStatus.FAILED;

                            if (isRecommendationSuccess) {
                                showNoticeMessage(
                                    NoticeType.success,
                                    getGridRecommendationApplyStatusMessage(
                                        action.recommendationType,
                                        action.itemName
                                    )
                                );
                            } else {
                                showNoticeMessage(
                                    NoticeType.error,
                                    getGridRecommendationErrorStatusMessage(
                                        action.recommendationType,
                                        action.itemName
                                    )
                                );
                            }

                            return of(resetGridData());
                        }
                    )
                );
            }
        )
    );
};

const getOutdoorRejectReasonsFullInfo = (
    reasons: Array<ModerationRejectReason>,
    deps: EpicDeps
): Observable<Array<ModerationRejectReason>> => {
    const outdoorReasonsIndex = reasons
        .map(item => item.key)
        .indexOf(OUTDOOR_ID_KEY);

    if (outdoorReasonsIndex === -1) {
        return of([]);
    }

    const outdoorReasonsInfo = reasons[outdoorReasonsIndex];
    let outdoorInputReasons: OutdoorRejectFullReason = {
        key: OUTDOOR_ID_KEY,
        reasons: []
    };
    if (outdoorReasonsInfo.key === OUTDOOR_ID_KEY) {
        outdoorInputReasons = outdoorReasonsInfo;
    }

    const outdoorIds: Set<string> = new Set();

    outdoorInputReasons.reasons.forEach(item => {
        item.externalId.forEach(id => {
            outdoorIds.add(id);
        });
    });

    const initialFullReasons: Array<ModerationRejectReason> = [];

    return from(
        deps.restApiManager.getExternalReasonsText(Array.from(outdoorIds))
    ).pipe(
        map(outdoorReasons => {
            return outdoorInputReasons.reasons.map(
                (item: ModerationRejectOutdoorReasonsItem) => {
                    const outdoorFullReasons = Array.from(
                        item.externalId
                    ).reduce((fullReasons, id) => {
                        if (!outdoorReasons.reasons[id]) {
                            return fullReasons.concat({
                                key: ModerationRejectKey.spam
                            });
                        }

                        const {
                            title,
                            content: text
                        } = mapExternalModerationRejectReasonFromApiFormat(
                            outdoorReasons.reasons[id]
                        );

                        return fullReasons.concat({
                            key: EXTERNAL_REASON_KEY,
                            title,
                            text
                        });
                    }, initialFullReasons);

                    return {
                        ...item,
                        reasons: outdoorFullReasons
                    };
                }
            );
        }),
        map(outdoorFullInfo => [
            {
                reasons: outdoorFullInfo,
                key: outdoorInputReasons.key
            }
        ])
    );
};

const getExternalRejectReasonsFullInfo = (
    reasons: Array<ModerationRejectReason>,
    deps: EpicDeps
): Observable<Array<ModerationRejectReason>> => {
    const externalItems = reasons.reduce(
        (sum: Array<string>, curr: ModerationRejectReason) => {
            if (curr.key === EXTERNAL_ID_KEY) {
                curr.externalId.forEach(externalIdItem =>
                    sum.push(externalIdItem)
                );
            }

            return sum;
        },
        []
    );

    if (externalItems.length === 0) {
        return of([]);
    }

    return from(deps.restApiManager.getExternalReasonsText(externalItems)).pipe(
        map(externalReasons => {
            const externalFullInfo: Array<ModerationRejectReason> = [];
            Object.keys(externalReasons.reasons).forEach(i => {
                const {
                    title,
                    content: text
                } = mapExternalModerationRejectReasonFromApiFormat(
                    externalReasons.reasons[i]
                );

                externalFullInfo.push({
                    key: EXTERNAL_REASON_KEY,
                    title,
                    text
                });
            });

            if (externalReasons.errors.length) {
                externalFullInfo.push({
                    key: ModerationRejectKey.spam
                });
            }

            return externalFullInfo;
        })
    );
};

export const getExternalReasonsContent = (
    inputParams: {
        items: ModerationRejectReason[];
        contactEmail: string | undefined;
    },
    deps: EpicDeps
) => {
    const inputItems = inputParams.items;

    const fullItemsInfo = inputItems.filter(
        item =>
            ![OUTDOOR_ID_KEY, EXTERNAL_ID_KEY, OTHER_REASON_KEY].includes(
                item.key
            )
    );

    const outdoorReasonsFullInfo$ = getOutdoorRejectReasonsFullInfo(
        inputItems,
        deps
    );

    const externalReasonsFullInfo$ = getExternalRejectReasonsFullInfo(
        inputItems,
        deps
    );

    // todo объединить логику двух обсерваболов в один
    //  DIRECT-93277 author: mrronuar
    return forkJoin(outdoorReasonsFullInfo$, externalReasonsFullInfo$).map(
        ([outdoorReasonsFullInfo, externalReasonsFullInfo]) => {
            return {
                contactEmail: inputParams.contactEmail,
                items: fullItemsInfo.concat(
                    outdoorReasonsFullInfo,
                    ...externalReasonsFullInfo
                )
            };
        }
    );
};

const getBannerModerationRejectReasonsEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$
        .ofType(GET_BANNER_MODERATION_REJECT_REASONS)
        .mergeMap(({ bid }: GetBannnerModerationRejectReasons) => {
            const state = store$.value;
            const { login } = state.commonData;

            return Observable.fromPromise(
                deps.entitiesDataProvider.getCalloutsIds(login)
            )
                .mergeMap(
                    (calloutsIds): Observable<Action> => {
                        return Observable.fromPromise(
                            deps.restApiManager.getModerationRejectReasons(
                                bid,
                                calloutsIds
                            )
                        )
                            .map(data => {
                                const items = mapBannerModerationRejectReasonsFromApiFormat(
                                    data
                                );

                                const contactEmail = mapModerationEmailContactFromApiFormat(
                                    data,
                                    state.commonData.operator.isAgency
                                );

                                const params = {
                                    items,
                                    contactEmail
                                };
                                return params;
                            })
                            .mergeMap(params => {
                                return getExternalReasonsContent(params, deps);
                            })
                            .map(params => {
                                const updateBannerModerationRejectReasons$ = updateBannerModerationRejectReasons(
                                    bid,
                                    params
                                );
                                return updateBannerModerationRejectReasons$;
                            })
                            .catch(() => {
                                return Observable.of(
                                    setBannerModerationRejectReasonsError(
                                        bid,
                                        i18n(
                                            'fetch-moderation-reject-reasons-error'
                                        )
                                    )
                                );
                            });
                    }
                )
                .catch(
                    (): Observable<Action> => {
                        return Observable.of(
                            setBannerModerationRejectReasonsError(
                                bid,
                                i18n('fetch-moderation-reject-reasons-error')
                            )
                        );
                    }
                );
        });
};

const getGroupModerationRejectReasonsEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.ofType(GET_GROUP_MODERATION_REJECT_REASONS).mergeMap(
        ({ groupId }: GetGroupModerationRejectReasons): Observable<Action> => {
            const state = store$.value;
            const groupInfo = state.grid.gridData.data.find(
                group => group && group.id === groupId
            ) as Group;

            return Observable.fromPromise(
                deps.entitiesDataProvider.getGroupBanner(
                    state.commonData.login,
                    groupInfo.campaign.id,
                    groupId
                )
            )
                .mergeMap(({ id, calloutsIds }) => {
                    return Observable.fromPromise(
                        deps.restApiManager.getModerationRejectReasons(
                            id,
                            calloutsIds
                        )
                    )
                        .map(data => {
                            const items = mapGroupModerationRejectReasonsFromApiFormat(
                                data
                            );

                            const contactEmail = mapModerationEmailContactFromApiFormat(
                                data,
                                state.commonData.operator.isAgency
                            );

                            const params = {
                                items: items,
                                contactEmail: contactEmail
                            };
                            return params;
                        })
                        .mergeMap(params => {
                            return getExternalReasonsContent(params, deps);
                        })
                        .map(params => {
                            const updateBannerModerationRejectReasons$ = updateGroupModerationRejectReasons(
                                groupId,
                                params
                            );

                            return updateBannerModerationRejectReasons$;
                        });
                })
                .catch(() => {
                    return Observable.of(
                        setGroupModerationRejectReasonsError(
                            groupId,
                            i18n('fetch-moderation-reject-reasons-error')
                        )
                    );
                });
        }
    );
};

const startBannerAimingEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$.ofType(START_BANNER_AIMING).mergeMap(
        (action: StartBannerAimingAction): Observable<Action> => {
            return Observable.fromPromise(
                requestHiddenFrame(
                    UrlHelpers.getBannerAimingUrl(
                        action.login,
                        action.bannerId,
                        action.cookieTtl
                    )
                )
            )
                .mergeMap(content => {
                    if (content !== 'ok') {
                        throw new Error();
                    }
                    const ypCookie = Cookie.get('yp');
                    const adocMatch =
                        ypCookie &&
                        ypCookie.match(/.*?(\d+\.adoc\..+)(?:\.\w|$)/);
                    let adoc;

                    if (adocMatch) {
                        [, adoc] = adocMatch;
                    }

                    if (!adoc) {
                        throw new Error();
                    }

                    return requestHiddenFrame(
                        UrlHelpers.getAdfoxBannerAimingUrl(
                            encodeURIComponent(adoc),
                            action.cookieTtl
                        )
                    );
                })
                .map(content => {
                    if (content !== 'ok') {
                        throw new Error();
                    }

                    showNoticeMessage(
                        NoticeType.success,
                        i18n('bannerAimingSuccessful')
                    );

                    return setBannerAimingPopup(undefined);
                })
                .catch(
                    (): Observable<Action> => {
                        showNoticeMessage(
                            NoticeType.error,
                            i18n('bannerAimingFailed')
                        );
                        return Observable.concat(
                            Observable.fromPromise(
                                requestHiddenFrame(
                                    UrlHelpers.getBannerAimingRollbackUrl(
                                        action.login
                                    )
                                )
                            ).map(() => dummyAction),
                            Observable.of(setBannerAimingPopupPending(false))
                        );
                    }
                );
        }
    );
};

const updateGridFilterDictEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$
        .ofType(UPDATE_GRID_FILTER_DICT)
        .map((action: UpdateGridFilterDict) => {
            const state = store$.value;
            const { login } = state.commonData;
            const { filterDict } = action;

            if (filterDict) {
                Session.setValueToCurrentSession(login, {
                    gridFilter: filterDict
                });
            }

            return dummyAction;
        });
};

const addEntitySuccessEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(ENTITY_ADD_SUCCESS).mergeMap(
        (action: EntityAddSuccess): Observable<Action> => {
            const state = store$.value;
            const login = state.commonData.client.login;
            const sourceParams = selectGridSourceParams(state);

            if (login === undefined) {
                throw new Error('login is undefined');
            }

            return Observable.fromPromise(
                deps.commonDataProvider.awaitClientMutations(login)
            )
                .do(() => {
                    showNoticeMessage(
                        NoticeType.success,
                        i18n('popup-save-success')
                    );
                })
                .mergeMap(() => {
                    const result: Action[] = [closeEditPopup()];

                    const campaignType =
                        state.grid.editedEntity &&
                        state.grid.editedEntity.campaignType;
                    const data = action.data;
                    let contextIds: string[];
                    let context: GridContextType;
                    let view: GridViewType;

                    switch (data.type) {
                        case GridEditedEntityType.Campaign:
                            contextIds = [data.cid];
                            context = campaigns;
                            view = groups;
                            break;
                        case GridEditedEntityType.Group:
                            contextIds = [data.adgroupId];
                            context = groups;
                            view = banners;
                            break;
                        default:
                            throw new Error('Неподдерживаемый тип');
                    }

                    let query;

                    if (sourceParams) {
                        const { campaignsIds, groupsIds } = sourceParams;

                        query = GridScreenLinkBuilder.getContextTypeQueryRelevantParams(
                            context,
                            view,
                            {
                                login,
                                contextIds,
                                campaignsIds,
                                groupsIds
                            },
                            sourceParams
                        );
                    } else {
                        const { router } = store$.value;

                        query = GridScreenLinkBuilder.getContextTypeUrl(
                            context,
                            view,
                            {
                                login,
                                contextIds
                            },
                            router.pathname
                        ).query;
                    }

                    if (query) {
                        query[
                            GridScreenUrlSearchQueryParams.calcType
                        ] = mapCampaignTypeToCalcType(campaignType);
                    }

                    result.push(
                        resetGridData(),
                        push(
                            {
                                pathname: UrlHelpers.createNewDirectUrlPathByParams(
                                    GRID_PREFIX,
                                    view
                                ),
                                query
                            },
                            {
                                persistQuery: true
                            }
                        ),
                        updateSelection([])
                    );

                    return result;
                })
                .catch((err: ApiMethodExecutingError | Error) => {
                    showNoticeMessage(
                        NoticeType.error,
                        err instanceof ApiMethodExecutingError
                            ? err.getMessage()
                            : err.message
                    );

                    return Observable.of(dummyAction);
                });
        }
    );
};

const editEntitySuccessEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(ENTITY_EDIT_SUCCESS).mergeMap(
        (): Observable<Action> => {
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);

            return Observable.fromPromise(
                deps.commonDataProvider.awaitClientMutations(sourceParams.login)
            )
                .do(() => {
                    showNoticeMessage(
                        NoticeType.success,
                        i18n('popup-save-success')
                    );
                })
                .mergeMap(
                    (): Observable<Action> =>
                        of(resetGridData(), closeEditPopup())
                )
                .catch(
                    (
                        err: ApiMethodExecutingError | Error
                    ): Observable<Action> => {
                        showNoticeMessage(
                            NoticeType.error,
                            err instanceof ApiMethodExecutingError
                                ? err.getMessage()
                                : err.message
                        );

                        return Observable.of(dummyAction);
                    }
                );
        }
    );
};

const updateGridFilterPeriodEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$
        .ofType(UPDATE_GRID_FILTER_PERIOD)
        .map((action: UpdateGridFilterPeriod) => {
            const state = store$.value;
            const { login } = state.commonData;
            const { period } = action;
            Session.setValueToCurrentSession(login, {
                statPeriod: period
            });

            return dummyAction;
        });
};

const fetchAdjustmentInfoEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(GRID_FETCH_ADJUSMENT_INFO).mergeMap(
        (action: GridFetchAdjustmentInfo): Observable<Action> => {
            return Observable.fromPromise(
                deps.restApiManager.ajaxRefineMinusWords({
                    minusWords: action.params.minusWords,
                    phrase: action.params.phrase,
                    geo: action.params.geo
                })
            )
                .map((response: RefineMinusWordsResponse) => {
                    const { items = [] } = store$.value.grid.phraseAdjustment;

                    const newItems = mapRefineMinusWordsReponseToAdjustmentItems(
                        response
                    );

                    return gridChangeAdjustmentData({
                        hasMoreItems: Boolean(response.has_more),
                        items: [...items, ...newItems]
                    });
                })
                .catch(() =>
                    Observable.of(
                        gridChangeAdjustmentData({
                            items: []
                        })
                    )
                );
        }
    );
};

const updateAdjustmentForecast: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) =>
    action$.pipe(
        ofType(UPDATE_ADJUSTMENT_FORECAST),
        debounceTime(500),
        mergeMap(
            (action: UpdateAdjustmentForecast): Observable<Action> => {
                if (!store$.value.grid.phraseAdjustment.visible) {
                    return of();
                }

                return from(
                    deps.restApiManager.ajaxPhraseStat({
                        minusWords: action.params.minusWords,
                        phrase: action.params.phrase,
                        geo: action.params.geo
                    })
                ).pipe(
                    mergeMap(
                        (
                            response: AjaxPhraseStatResponse
                        ): Observable<Action> => {
                            const showsForecast = Number(response);

                            return of(
                                gridChangeAdjustmentData({
                                    showsForecast
                                })
                            );
                        }
                    ),
                    catchError(
                        (): Observable<Action> =>
                            of(
                                gridChangeAdjustmentData({
                                    showsForecast: undefined
                                })
                            )
                    )
                );
            }
        )
    );

const switchOnlyFavoriteCampaignsFilter: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$
        .ofType(SWICH_ONLY_FAVORITE_CAMPAIGNS_FILTER)
        .mapTo(resetGridData());
};

const openMinusPhraseSelectorGridModalEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.ofType(OPEN_MINUS_PHRASE_SELECTOR_GRID_MODAL).mergeMap(
        (): Observable<
            | DummyAction
            | UpdateMinusPhraseItemsGridInModal
            | ShowErrorMinusPhraseItemsGridInModal
        > => {
            const offset = 0;
            const constants = store$.value.commonData.constants;

            if (!constants) {
                return Observable.of(dummyAction);
            }

            const limit =
                constants.minusPhraseLibraryConstants.maxLibraryPacksCount;

            return Observable.fromPromise(
                deps.minusPhraseLibraryDataProvider.fetchMinusPhraseLibraryData(
                    offset,
                    limit
                )
            )
                .map((response: FetchMinusPhraseLibraryDataResult) => {
                    return updateMinusPhraseItemsGridInModal(
                        response.data.reduce(
                            (
                                acc: MinusPhraseSelectorItemsData[],
                                item: MinusPhraseLibraryRow,
                                pos: number
                            ) => {
                                acc[offset + pos] = {
                                    name: item.name,
                                    id: String(item.id),
                                    preview: item.minusKeywords
                                };

                                return acc;
                            },
                            []
                        )
                    );
                })
                .catch(() => {
                    return Observable.of(
                        showErrorMinusPhraseItemsGridInModal()
                    );
                });
        }
    );
};

const bindMinusPhraseToGridGroupsEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.ofType(BIND_MINUS_PHRASE_TO_GRID_GROUPS).mergeMap(
        (): Observable<Action> => {
            const {
                selectedMinusPhrasesIds
            } = store$.value.grid.minusPhrasesSelectorData;
            const { groups: selectedGroups } = store$.value.grid.selectionInfo;
            const {
                campaigns: selectedCampaigns
            } = store$.value.grid.selectionInfo;

            return Observable.fromPromise(
                deps.minusPhraseLibraryMutationExecutor.updateAdGroupToMinusKeywordsPacks(
                    {
                        minusKeywordsPackIds: selectedMinusPhrasesIds,
                        adGroupIds: selectedGroups,
                        action: GdUpdateAdGroupMinusKeywordsActionInput.ADD
                    }
                )
            )
                .mergeMap(
                    (response): Observable<Action> => {
                        const failureGroupsIds = selectedGroups.filter(
                            item => !response.data.includes(item)
                        );

                        return of(
                            closeMinusPhraseSelectorGridModal(),
                            showMinusPhraseBindSuccessMessage(
                                response.data.length,
                                selectedGroups.length,
                                selectedMinusPhrasesIds.length,
                                failureGroupsIds,
                                selectedCampaigns
                            )
                        );
                    }
                )
                .catch(
                    (): Observable<Action> => {
                        return of(showErrorMinusPhraseItemsGridInModal());
                    }
                );
        }
    );
};

const unbindMinusPhraseToGridGroupsEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.ofType(UNBIND_MINUS_PHRASE_TO_GRID_GROUPS).mergeMap(
        (): Observable<Action> => {
            const {
                selectedMinusPhrasesIds
            } = store$.value.grid.minusPhrasesSelectorData;
            const { groups: selectedGroups } = store$.value.grid.selectionInfo;
            const {
                campaigns: selectedCampaigns
            } = store$.value.grid.selectionInfo;

            return Observable.fromPromise(
                deps.minusPhraseLibraryMutationExecutor.updateAdGroupToMinusKeywordsPacks(
                    {
                        minusKeywordsPackIds: selectedMinusPhrasesIds,
                        adGroupIds: selectedGroups,
                        action: GdUpdateAdGroupMinusKeywordsActionInput.REMOVE
                    }
                )
            )
                .mergeMap(
                    (response): Observable<Action> => {
                        const failureGroupsIds = selectedGroups.filter(
                            item => !response.data.includes(item)
                        );

                        return of(
                            closeMinusPhraseSelectorGridModal(),
                            showMinusPhraseUnbindSuccessMessage(
                                response.data.length,
                                selectedGroups.length,
                                selectedMinusPhrasesIds.length,
                                failureGroupsIds,
                                selectedCampaigns
                            )
                        );
                    }
                )
                .catch(
                    (): Observable<Action> => {
                        return of(showErrorMinusPhraseItemsGridInModal());
                    }
                );
        }
    );
};

const showMinusPhraseBindSuccessMessageEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$
        .ofType(SHOW_MINUS_PHRASE_BIND_SUCCESS_MESSAGE)
        .do((action: ShowMinusPhraseBindSuccessMessage) => {
            const {
                successCount,
                totalCount,
                groupsIds,
                campaignsIds,
                selectedMinusPhrasesCount
            } = action;
            const { login } = store$.value.commonData;
            const message = getSuccessMinusPhraseBindingMessage(
                totalCount,
                successCount,
                selectedMinusPhrasesCount
            );
            const serializeFilterToErrorGroups = expressionToString({
                field: GroupCriteriaSetTitles[GroupCriteriaKey.id],
                operator: Operator.EQUALS,
                value: {
                    type: FilterExpressionValueType.numberSet,
                    value: groupsIds
                }
            });
            const link = UrlHelpers.getGroupsListUrl({
                ulogin: login,
                'message-type': GridAlertMessageType.minusPhraseBindingError
            });
            const errorMessage = getErrorMinusPhraseBindingMessage(
                selectedMinusPhrasesCount,
                totalCount
            );

            // Подготавливаем новую страницу перехода
            Session.setValueToCurrentSession(login, {
                alertMessageFilter: {
                    [groups]: serializeFilterToErrorGroups
                },
                campaignsIds: campaignsIds
            });

            const successProportion = successCount / totalCount;

            if (successProportion === 0) {
                showNoticeMessageWithLink(
                    NoticeType.error,
                    errorMessage,
                    link,
                    i18n('link-message-groups')
                );
            } else if (successProportion === 1) {
                showNoticeMessage(NoticeType.success, message);
            } else if (successProportion <= ERROR_PROPORTION_CHECKPOINT) {
                showNoticeMessageWithLink(
                    NoticeType.error,
                    message,
                    link,
                    i18n('link-message-groups')
                );
            } else if (successProportion >= SUCCESS_PROPORTION_CHECKPOINT) {
                showNoticeMessageWithLink(
                    NoticeType.success,
                    message,
                    link,
                    i18n('link-message-groups')
                );
            } else {
                showNoticeMessageWithLink(
                    NoticeType.warning,
                    message,
                    link,
                    i18n('link-message-groups')
                );
            }
        })
        .mapTo(resetGridData());
};

const showMinusPhraseUnbindSuccessMessageEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$
        .ofType(SHOW_MINUS_PHRASE_UNBIND_SUCCESS_MESSAGE)
        .do((action: ShowMinusPhraseUnbindSuccessMessage) => {
            const {
                successCount,
                totalCount,
                groupsIds,
                campaignsIds,
                selectedMinusPhrasesCount
            } = action;
            const { login } = store$.value.commonData;
            const message = getSuccessMinusPhraseUnbindingMessage(
                totalCount,
                successCount,
                selectedMinusPhrasesCount
            );
            const errorMessage = getErrorMinusPhraseUnbindingMessage(
                selectedMinusPhrasesCount,
                totalCount
            );

            const serializeFilterToErrorGroups = expressionToString({
                field: GroupCriteriaSetTitles[GroupCriteriaKey.id],
                operator: Operator.EQUALS,
                value: {
                    type: FilterExpressionValueType.numberSet,
                    value: groupsIds
                }
            });
            const link = UrlHelpers.getGroupsListUrl({
                ulogin: login,
                'message-type': GridAlertMessageType.minusPhraseUnbindingError
            });

            // Подготавливаем новую страницу перехода
            Session.setValueToCurrentSession(login, {
                alertMessageFilter: {
                    [groups]: serializeFilterToErrorGroups
                },
                campaignsIds: campaignsIds
            });

            const successProportion = successCount / totalCount;

            if (successProportion === 0) {
                showNoticeMessageWithLink(
                    NoticeType.error,
                    errorMessage,
                    link,
                    i18n('link-message-groups')
                );
            } else if (successProportion === 1) {
                showNoticeMessage(NoticeType.success, message);
            } else if (successProportion <= ERROR_PROPORTION_CHECKPOINT) {
                showNoticeMessageWithLink(
                    NoticeType.error,
                    message,
                    link,
                    i18n('link-message-groups')
                );
            } else if (successProportion >= SUCCESS_PROPORTION_CHECKPOINT) {
                showNoticeMessageWithLink(
                    NoticeType.success,
                    message,
                    link,
                    i18n('link-message-groups')
                );
            } else {
                showNoticeMessageWithLink(
                    NoticeType.warning,
                    message,
                    link,
                    i18n('link-message-groups')
                );
            }
        })
        .mapTo(resetGridData());
};

const openDuplicateGroupsModalEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$
        .ofType(OPEN_DUPLICATE_GROUPS_MODAL)
        .mergeMap((action: OpenDuplicateGroupsModal) => {
            const { login, campaignsIds, groupsCacheKey, groupsIds } = action;

            return Observable.fromPromise(
                deps.entitiesDataProvider.getGroupsForDuplicateAction(
                    login,
                    campaignsIds,
                    groupsIds,
                    groupsCacheKey
                )
            )
                .map((data: Array<DuplicateItem>) => {
                    return updateDuplicateGroupsItemsData(data, true);
                })
                .catch(() => {
                    showNoticeMessage(NoticeType.error, i18n('operationError'));

                    return Observable.empty();
                });
        });
};

const closeAlertGridErrorEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    const { router } = store$.value;

    return action$.ofType(CLOSE_ALERT_GRID_ERROR).map(() => {
        const query = omit(router.query, [
            GridScreenUrlSearchQueryParams.messageType
        ]) as Query;

        return changeLocation(router.pathname, query, false);
    });
};

export {
    updateSourceParamsEpic,
    fetchSuggestDataEpic,
    requestRowEpic,
    resetGridDataEpic,
    fetchGridGroupsCountsEpic,
    fetchTooltipDataEpic,
    replacePhrasesEpic,
    getPhrasesReplacePreviewEpic,
    finishSearchAndReplaceLoadingEpic,
    switchToOldInterfaceEpic,
    updateAdditionalFilterEpic,
    loadBannersPreviewEpic,
    submitGridRecommendationEpic,
    setGridDocumentTitleEpic,
    getGridRecommendationApplyStatusEpic,
    getBannerModerationRejectReasonsEpic,
    getGroupModerationRejectReasonsEpic,
    startBannerAimingEpic,
    updateGridFilterDictEpic,
    updateGridFilterPeriodEpic,
    addEntitySuccessEpic,
    editEntitySuccessEpic,
    openMinusPhraseSelectorGridModalEpic,
    fetchAdjustmentInfoEpic,
    bindMinusPhraseToGridGroupsEpic,
    showMinusPhraseBindSuccessMessageEpic,
    updateAdjustmentForecast,
    unbindMinusPhraseToGridGroupsEpic,
    showMinusPhraseUnbindSuccessMessageEpic,
    switchOnlyFavoriteCampaignsFilter,
    openDuplicateGroupsModalEpic,
    EXTERNAL_REASON_KEY,
    closeAlertGridErrorEpic,
    updateCalcTypeFilterEpic
};
